import { Container, Text } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { RelatanceLockup } from "../components/Brand/RelatanceLockup";
import { useGetCurrentUserAndOrganizationsQuery } from "../graphql/generated/types.gen";
import { useAuthCompat } from "../hooks/useAuthCompat";

export const Route = createFileRoute("/about")({
	component: About,
});

function About() {
	const { user, isLoading } = useAuthCompat();
	const { data: userData } = useGetCurrentUserAndOrganizationsQuery({
		skip: !user,
	});

	// Redirect to welcome if not authenticated
	useEffect(() => {
		if (!isLoading && (!user || !userData?.currentUser)) {
			window.location.href = "/welcome";
		}
	}, [user, userData, isLoading]);

	return (
		<div
			className="min-h-[calc(100vh-var(--header-height))] flex items-center justify-center px-4 py-8"
			style={{ background: "var(--canvas)" }}
		>
			<Container size="sm">
				<div className="plate flex flex-col items-center text-center gap-6">
					<RelatanceLockup />
					<span className="kicker">About</span>
					<Text style={{ color: "var(--ink)", lineHeight: 1.62 }}>
						Hello from About.
					</Text>
				</div>
			</Container>
		</div>
	);
}
